/* unplugin-vue-components disabled */import { render } from "./PathEditor.vue?vue&type=template&id=1c537bd6&scoped=true&ts=true"
import script from "./PathEditor.vue?vue&type=script&lang=ts"
export * from "./PathEditor.vue?vue&type=script&lang=ts"

import "./PathEditor.vue?vue&type=style&index=0&id=1c537bd6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c537bd6"]])

export default __exports__